import React from 'react';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAuth, useAppSelector } from '../../helpers/hooks';
import { toggleSidebar, setSidebarOpen } from '../../slices/layout/layoutSlice';
import { logout } from '../../slices/auth/authSlice';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

const Header: React.FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const { sidebarOpen } = useAppSelector((state) => state.layout);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggle = () => setDropdownOpen(!dropdownOpen);

  const handleLogout = () => {
    dispatch(logout());
  };

  const toogleMenuBtn = () => {
    const windowWidth = window.innerWidth;

    if (windowWidth < 992) {
      // Mobile: show sidebar with overlay
      document.body.classList.toggle('vertical-sidebar-enable');
    } else {
      // Desktop: toggle sidebar size (lg <-> sm)
      const currentSize = document.documentElement.getAttribute('data-sidebar-size');
      if (currentSize === 'lg') {
        document.documentElement.setAttribute('data-sidebar-size', 'sm');
        dispatch(setSidebarOpen(false));
      } else {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
        dispatch(setSidebarOpen(true));
      }
    }
  };

  return (
    <header className="app-header" id="page-topbar">
      <div className="d-flex align-items-center">
        {/* Hamburger Menu */}
        <button
          type="button"
          className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
          id="topnav-hamburger-icon"
          onClick={toogleMenuBtn}
        >
          <span className={`hamburger-icon ${window.innerWidth >= 992 && !sidebarOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>

      <div className="d-flex align-items-center gap-1">
        {/* User Dropdown */}
        <Dropdown isOpen={dropdownOpen} toggle={toggle} className="user-dropdown">
          <DropdownToggle tag="button" type="button" className="dropdown-toggle">
            <span className="user-avatar">
              {user?.firstName?.charAt(0)}{user?.lastName?.charAt(0)}
            </span>
            <span className="user-info d-none d-md-block">
              <span className="user-name">{user?.firstName} {user?.lastName}</span>
              <span className="user-role">{user?.role?.displayName}</span>
            </span>
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <h6 className="dropdown-header">Hoş Geldin {user?.firstName}!</h6>
            <DropdownItem tag={Link} to="/settings">
              <i className="ri-settings-4-line text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Ayarlar</span>
            </DropdownItem>
            <div className="dropdown-divider"></div>
            <DropdownItem onClick={handleLogout} className="text-danger">
              <i className="ri-logout-box-r-line text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Çıkış Yap</span>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </header>
  );
};

export default Header;
